export const mockClientesAsesoria = [
  {
    id: 1,
    nombre: 'Carlos Martínez Delgado',
    email: 'carlos.martinez@email.com',
    telefono: '+34 612 345 678',
    plan_contratado: 'Premium',
    fecha_inicio: '2025-10-15',
    notas: 'Empresario del sector inmobiliario. Preocupado por su imagen en reuniones con inversores.',
    activo: true,
  },
  {
    id: 2,
    nombre: 'María Elena Sousa',
    email: 'maria.sousa@email.com',
    telefono: '+34 623 456 789',
    plan_contratado: 'Esencial',
    fecha_inicio: '2025-11-01',
    notas: 'Directora de marketing. Necesita renovar su estilo para conferencias internacionales.',
    activo: true,
  },
  {
    id: 3,
    nombre: 'Javier Ruiz-Funes',
    email: 'javier.rf@email.com',
    telefono: '+34 634 567 890',
    plan_contratado: 'Integral',
    fecha_inicio: '2025-08-20',
    notas: 'Familiar de la costura. Presentador de televisión. Alto perfil público.',
    activo: true,
  },
  {
    id: 4,
    nombre: 'Ana Belén García',
    email: 'ana.garcia@email.com',
    telefono: '+34 645 678 901',
    plan_contratado: 'Premium',
    fecha_inicio: '2025-12-10',
    notas: 'Chef de alta cocina. Inaugurando restaurante en Madrid. Necesita looks de cocina-versátil.',
    activo: true,
  },
];